module.exports = __webpack_public_path__ + "static/blog_performance_measurement-f8ac129f2a957f1bf7ba700205e684ac.jpg";